import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { ModalModule } from 'ngx-bootstrap/modal';
import { StepsModule } from 'primeng/steps';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgxMaskModule } from 'ngx-mask'


import { AppComponent } from './app.component';
import { FunnelComponent } from './funnel/funnel.component';
import { ThankYouComponent } from './thank-you/thank-you.component';

const routes: Routes = [
  { path: '', component: FunnelComponent },
  { path: 'thank-you', component: ThankYouComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    FunnelComponent,
    ThankYouComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    MatInputModule,
    MatButtonModule,
    RoundProgressModule,
    RouterModule.forRoot(routes),
    FormsModule,
    HttpClientModule,
    NgOtpInputModule,
    ModalModule.forRoot(),
    StepsModule,
    GooglePlaceModule,
    NgxMaskModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
